const gsv = window.LOCAL_CONFIG.QUOTE_GSV
const ctl_gsv = window.LOCAL_CONFIG.CTL_GSV
/**
 * 分时图数据接口地址
 */
export function getTrend (option) {
  return window.http.jsonRequest(gsv + '/ext/get_trend', option)
}
/**
 * 5日分时图数据接口地址
 */
export function getTrendMinute (option) {
  return window.http.jsonRequest(gsv + '/ext/get_trend_minute', option)
}
/**
 * 日K线图数据接口地址
 */
export function getKline (option) {
  return window.http.jsonRequest(gsv + '/ext/get_kline', option)
}
/**
 * 分笔成交数据接口地址
 */
export function getTicksList (option) {
  return window.http.jsonRequest(gsv + '/ext/get_ticks_list', option)
}
/**
 * 商品列表查询接口
 *
 * @returns {*}
 */
export function getGoodsList (option) {
  return window.fetch.post(gsv + '/ext/get_goods_list', option)
}
/**
 * 获取商品信息
 *
 * @returns {*}
 */
export function getGoodsInfo (option) {
  return window.fetch.post(ctl_gsv + '/ext/f10/get_public_f10', option)
}

/**
 * 获取服务器时间
 * @param {*} userId
 * @param {*} token 
 */
export function getServerTime (option = {}) {
  return window.fetch.post(gsv + '/ext/get_server_time', option)
}
